import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { GetImagesResponse } from '@responses/images';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

import type { QueryFactory } from './factory.types';

const IMAGES_URI = 'images';

export const getImages = async (): Promise<GetImagesResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: `${import.meta.env.VITE_API_URL}/${IMAGES_URI}`,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const imageQueries = {
  list: () =>
    queryOptions({
      queryKey: ['images'] as const,
      queryFn: getImages,
    }),
} satisfies QueryFactory;
